import React, {useEffect, useState} from 'react';
import {useCareerLanguage} from './CareerLanguage';

// The active language-specific notice comes from the API, not a bundled draft.
export function useCareerPrivacyNotice(enabled=true) {
  const {lang}=useCareerLanguage();
  const [state,setState]=useState({lang:'',notice:null,loading:false});
  const [retry,setRetry]=useState(0);
  useEffect(()=>{
    if(!enabled)return;
    let alive=true;
    const controller=new AbortController();
    setState({lang,notice:null,loading:true});
    (async()=>{
      try{
        const response=await fetch(process.env.REACT_APP_API_BASE_URL+'/api/kariyer/profil/onay-metni/'+lang,{signal:controller.signal,cache:'no-store'});
        if(!response.ok)throw new Error('Notice unavailable');
        const data=await response.json();
        if(!Number.isInteger(data.id)||data.id===0||typeof data.surum!=='string'||!data.surum.trim()||typeof data.metin!=='string'||!data.metin.trim())throw new Error('Incomplete notice');
        if(alive)setState({lang,notice:data,loading:false});
      }catch{
        if(alive)setState({lang,notice:null,loading:false});
      }
    })();
    return ()=>{alive=false;controller.abort();};
  },[enabled,lang,retry]);
  const current=enabled&&state.lang===lang;
  return {notice:current?state.notice:null,loading:enabled&&(!current||state.loading),retry:()=>setRetry(x=>x+1)};
}

export function CareerRegistrationNotice({policy}) {
  const {t}=useCareerLanguage();
  return <section className="ca-privacy" aria-label={t('privacy')}>
    <p>{t('registrationPrivacyIntro')}</p>
    {policy.notice?<details><summary>{t('privacy')} · {policy.notice.surum}</summary><div className="ca-privacy-text" tabIndex={0}>{policy.notice.metin}</div></details>:
      <div role="status"><p>{t(policy.loading?'loading':'privacyPending')}</p>{!policy.loading&&<button className="ca-link" type="button" onClick={policy.retry}>{t('registrationPrivacyRetry')}</button>}</div>}
  </section>;
}
